import { render, staticRenderFns } from "./ChangelogModal.vue?vue&type=template&id=7db760c6&"
import script from "./ChangelogModal.vue?vue&type=script&lang=js&"
export * from "./ChangelogModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangelogModal.vue?vue&type=style&index=0&id=7db760c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ChangelogModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports